import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import './MainLayout.css';

const pageTitles: Record<string, { title: string; breadcrumbs?: { label: string; path?: string }[] }> = {
  '/': { title: 'Dashboard' },
  '/animals': { title: 'Buscar Animais', breadcrumbs: [{ label: 'Buscar Animais' }] },
  '/animals/new': { title: 'Cadastrar Animal', breadcrumbs: [{ label: 'Animais', path: '/animals' }, { label: 'Novo' }] },
  '/transfers': { title: 'Transferências', breadcrumbs: [{ label: 'Transferências' }] },
  '/animals/deceased': { title: 'Animais Falecidos', breadcrumbs: [{ label: 'Animais' }, { label: 'Falecidos' }] },
  '/news': { title: 'Notícias', breadcrumbs: [{ label: 'Notícias' }] },
  '/missing-animals': { title: 'Animais Desaparecidos', breadcrumbs: [{ label: 'Notícias', path: '/news' }, { label: 'Animais Desaparecidos' }] },
  '/missing-animals/report': { title: 'Reportar Desaparecimento', breadcrumbs: [{ label: 'Notícias', path: '/news' }, { label: 'Reportar' }] },
  '/profile': { title: 'Meu cadastro', breadcrumbs: [{ label: 'Meu cadastro' }] },
};

function getPageMeta(pathname: string): { title: string; breadcrumbs?: { label: string; path?: string }[] } {
  if (pageTitles[pathname]) return pageTitles[pathname];
  if (pathname.startsWith('/animals/') && pathname !== '/animals/new' && pathname !== '/animals/deceased') {
    return { title: 'Editar Animal', breadcrumbs: [{ label: 'Animais', path: '/animals' }, { label: 'Editar' }] };
  }
  return { title: 'PetID Brasil' };
}

const MainLayout: React.FC = () => {
  const location = useLocation();
  const { title, breadcrumbs } = getPageMeta(location.pathname);
  const [sidebarMobileOpen, setSidebarMobileOpen] = useState(false);

  return (
    <div className={`metronic-wrapper ${sidebarMobileOpen ? 'sidebar-mobile-open' : ''}`}>
      <Sidebar
        mobileOpen={sidebarMobileOpen}
        onMobileClose={() => setSidebarMobileOpen(false)}
      />
      <div className="metronic-main">
        <Header
          title={title}
          breadcrumbs={breadcrumbs}
          onMenuClick={() => setSidebarMobileOpen(true)}
        />
        <main className="metronic-content">
          <div className="content-container">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
